<template>
  <div style="display: flex;flex-direction: column; justify-content: space-between; align-items: center;">
    <div style="width: 100vw; bottom: -20px; position: relative; background-color: #7b7b7b; color: white; display: flex;flex-direction: row; justify-content: center; align-items: center;">
      <div :style="'padding: 50px; width: '+($store.getters.getScreenWidth < 1400 ? '98%' : '90%')+'; max-width: 1920px; display: flex;flex-direction: '+($store.getters.getScreenWidth<500 ? 'column' : 'row')+'; justify-content: space-between; align-items: flex-start; text-align: left;'">
        <span :style="'margin-bottom: '+($store.getters.getScreenWidth<500 ? '20px' : '')+'; font-size: 24px; font-weight: 500;'">
          get in touch <br>
          with us
        </span>
        <span v-if="$store.getters.getScreenWidth>=700" style="font-size: 18px; font-weight: 500;">
          Email 24x7<br>
          reachus@easytailorapp.com
        </span>
        <span style="font-size: 18px; font-weight: 500;">
          <span v-if="$store.getters.getScreenWidth<700">
            Email 24x7<br>
            reachus@easytailorapp.com<br><br>          
          </span>
          WhatsApp<br>
          <a href="http://wa.link/yockn2" style="color: white; text-decoration: none;">+91-934-886-2846</a>
        </span>
      </div>
    </div>
    <div style="width: 100vw; bottom: -20px; position: relative; background-color: #000; color: white; display: flex; flex-direction: column; justify-content: center; align-items: center;">
    <div :style="'margin-top: 30px; width: '+($store.getters.getScreenWidth < 1400 ? '98%' : '90%')+'; max-width: 1920px; '">
      <div :style="'display: flex; flex-direction: '+($store.getters.getScreenWidth>=650 ? 'row' : 'column')+'; justify-content: space-between; align-items: space-between;'">

          <div :style="'padding-left: '+($store.getters.getScreenWidth<1400 ? '30px' : '')+'; width: '+($store.getters.getScreenWidth<650 ? '100%' : '40%')+'; display: flex; flex-direction: column; align-items: flex-start; text-align: left;'">
            <span style="font-size: 20px; font-weight: 500;">
              ABOUT US
            </span>
            <span style="margin-top: 15px; padding-right: 30px;">
              Easy Tailor App (ETA) is a tailoring app developed by the Easy Tailor App LLP. We have devoted considerable resources researching the 
              tailoring businesses and have applied this research in the developement of our unique software package.
            </span>
          </div>
          <div :style="'padding-left: '+($store.getters.getScreenWidth<650 ? '30px' : '')+'; margin-top: '+($store.getters.getScreenWidth<650 ? '50px' : '')+'; width: '+($store.getters.getScreenWidth<650 ? '100%' : '20%')+'; display: flex; flex-direction: column; align-items: flex-start; text-align: left;'">
            <span style="font-size: 20px; font-weight: 500;">
              SUPPORT HOURS
            </span>
            <span style="margin-top: 15px;">
              Monday to Sunday
            </span>
            <span>
              {{$store.getters.getETATimings.support.start}} to {{$store.getters.getETATimings.support.end}}
            </span>
            <span>
              ({{$store.getters.getVisitorGeographyDetail.iso_code}} Timezone)
            </span>              
          </div>
          <div :style="'padding-left: '+($store.getters.getScreenWidth<650 ? '30px' : '')+'; margin-top: '+($store.getters.getScreenWidth<650 ? '50px' : '')+'; width: '+($store.getters.getScreenWidth<650 ? '100%' : '20%')+'; display: flex; flex-direction: column; align-items: flex-start; text-align: left;'">
              <span style="font-size: 20px; font-weight: 500;">
                BUSINESS ADDRESS
              </span>
              <span style="margin-top: 15px;">
                Plot No. 9, Industrial Estate, Patia,<br>Bhubaneswar, Odisha, India.
              </span>
              <span style="margin-top: 15px;">
                Monday to Saturday
              </span>
              <span>
                {{$store.getters.getETATimings.sales.start}} to {{$store.getters.getETATimings.sales.end}}
              </span>
              <span>
                ({{$store.getters.getVisitorGeographyDetail.iso_code}} Timezone)
              </span>        
          </div>
      </div>
      
    </div>
    <div style="width: 100%; text-align: center; margin-top: 50px; font-size: 12px; padding-bottom: 10px;">
      
      <div style="margin-bottom: 20px; width: 100%; display: flex; flex-direction: row; flex-wrap: wrap; justify-content: center; align-items: center;">
        <router-link 
          v-for="(data, index) in getMenuList" 
          :key="index" :to="data.path" 
          style="text-decoration: none; color: white; margin: 10px; font-size: 16px;">
            <span v-html="data.label">

            </span>
          </router-link>
      </div>
      
      <span v-html="getFooterNotes">

      </span>

    </div>
    </div>
  </div>
</template>

<script>
export default {
    computed: {
      getMenuList() {
        return [
          {label: 'Documentation', path: '/help'},
          {label: 'Terms &amp; Conditions', path: '/terms-and-conditions'},
          {label: 'Privacy Policy', path: '/privacy-policy'}
        ]
      },
      getFooterNotes() {
        return 'Easy Tailor App AKA ETA is developed and managed by Easy Tailor App LLP.<br>Easy Tailor App LLP All rights '+
            'reserved &copy; 2017-'+new Date().getFullYear()+'.<br>This site uses cookies. To find out more about cookies on this website, '+
            'see our privacy policy.<br><br>'
      }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Footer/Index.vue